import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  // Link
} from 'react-router-dom'

import './App.css';

import Terms from './components/Terms'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router>
          <Route exact path="/" component={Terms}/>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js